import { render, staticRenderFns } from "./NewNormalOffice2020.vue?vue&type=template&id=72a5b93c&scoped=true"
import script from "./NewNormalOffice2020.vue?vue&type=script&lang=js"
export * from "./NewNormalOffice2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a5b93c",
  null
  
)

export default component.exports